module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n      " + _vm._s(_vm.teammate.full_name) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "content teammate-content"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imageUrl),
      expression: "imageUrl"
    }],
    staticClass: "profile-photo",
    attrs: {
      "src": _vm.imageUrl
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.teammate.description))]), _vm._v(" "), _c('social-icons', {
    attrs: {
      "scale": 1.5,
      "website": _vm.teammate.links.website,
      "twitter": _vm.teammate.links.twitter,
      "github": _vm.teammate.links.github,
      "instagram": _vm.teammate.links.instagram,
      "linkedin": _vm.teammate.links.linkedin,
      "google-plus": _vm.teammate.links.google_plus,
      "facebook": _vm.teammate.links.facebook
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22054433","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Team/Teammate.vue
// module id = 906
// module chunks = 1